exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!./../../../node_modules/css-loader/index.js!./font-icons/style.css"), "");
exports.i(require("-!./../../../node_modules/css-loader/index.js!./github.css"), "");

// module
exports.push([module.id, "a{color:#ff4081;text-decoration:none}a:hover{text-decoration:underline}html{font-family:Roboto,sans-serif;-webkit-font-smoothing:antialiased}body,h1,h2,h3,h4,h5,h6{margin:0}body{font-size:15px;line-height:24px}.muidocs-checkbox-example{border:2px solid #ff9800;background-color:#4caf50}pre{white-space:pre-wrap;white-space:-moz-pre-wrap;white-space:-pre-wrap;white-space:-o-pre-wrap;word-wrap:break-word}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/app/css/main.css
 ** module id = 314
 ** module chunks = 0 1 2
 **/